import React from 'react'
import Contactus from '../Common/Contactus'
import MainBanner from '../page_content/MainBanner'
import whiterightarrow from "../../assets/images/white-rightarrow.svg";
import blackrightarrow from "../../assets/images/blackrightarrow.svg";
import sideCartimg from "../../assets/images/truckimg.png";
import closeicon from "../../assets/images/closeicon.svg";
import Header from '../Common/Header';

const Truck = () => {
    return (
        <>
            <Header />

            <div>
                <MainBanner page="PRODUCTS" />
                <section className=" aboutsection2" id="single-product">
                    <div className="container ">
                        <div className="bg-white">
                            <div className="text-section">
                                <h2 className="text-purple">Taxi & Transportation
                                </h2>
                                <p className="fw-medium">Cab booking and goods transport</p>
                                <div>
                                    Online Marketplace:&nbsp;The Goods Transport Website is designed to meet the needs of businesses and individuals seeking reliable transportation for products and cargo. Users can choose from a range of vehicles suitable for different load sizes and book services for local or long-distance transport. The platform will offer real-time tracking, route optimization, and delivery status updates, ensuring that goods are transported safely and efficiently. Secure payment gateways and transparent pricing will further enhance user trust and convenience.

                                </div>
                                <div>
                                    Product Catalogue:&nbsp;The website will feature an intuitive interface where patients can easily register, search for specialists by location, expertise, or availability, and book appointments. Doctors will have personalized profiles displaying their qualifications, specialties, and patient reviews, enabling better decision-making for users. The site will also host an integrated health blog offering articles, tips, and medical news to keep users informed about various conditions and treatments.
                                </div>
                                <div className="d-flex">
                                    <a
                                        href="#demo-modal"
                                        className="btn btn-black btn-purple  text-white"
                                    >
                                        View Project
                                        <img src={whiterightarrow} alt="" />
                                    </a>
                                </div>
                            </div>
                            <div className="image-section">
                                <img src={sideCartimg} alt="" />
                            </div>
                        </div>
                        <div id="demo-modal" className="modal">
                            <div className="modal__content">
                                <h2 className="text-purple">Get A Free Demo</h2>
                                <p className="fw-medium">
                                    Embrace Opportunity: A Pathway to Success
                                </p>
                                <div className="form-container">
                                    <div className="form-group">
                                        <label htmlFor="product">Select Product:</label>
                                        <select id="product" name="product">
                                            <option value="product1">Comercio</option>
                                            <option value="product2">Product 2</option>
                                            <option value="product3">Product 3</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="name">Name:</label>
                                        <input
                                            type="text"
                                            id="name"
                                            placeholder="MCL"
                                            name="name"
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="email">Email:</label>
                                        <input
                                            type="email"
                                            placeholder="info@gmail.com"
                                            id="email"
                                            name="email"
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="phone">Phone:</label>
                                        <input
                                            type="tel"
                                            placeholder="+91 9896570012"
                                            id="phone"
                                            name="phone"
                                            required
                                        />
                                    </div>
                                    <div className="form-group full-width">
                                        <label htmlFor="message">Message:</label>
                                        <textarea
                                            id="message"
                                            name="message"
                                            placeholder="Enter your message here"
                                            required
                                            defaultValue={""}
                                        />
                                    </div>
                                    <div className="form-group full-width button">
                                        <button className="btn btn-black" type="submit">
                                            Get a demo
                                        </button>
                                    </div>
                                </div>
                                <a href="#" className="modal__close">
                                    <img src={closeicon} alt="" />
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
                <section className id="Comercio-discription">
                    <div className="container ">
                        <div className="card-container bg-white text-gray">
                            <div>
                                <span className="fw-semi-bold"> Instant Cab Booking (Taxi):&nbsp;</span>
                                Users can easily book cabs instantly or schedule rides for later, choosing from various vehicle types like standard, luxury, or SUVs for a personalized experience.

                            </div>
                            <div>
                                <span className="fw-semi-bold">Real-Time GPS Tracking (Taxi):
                                </span>
                                Passengers can track their driver’s location, estimated arrival time, and route in real-time, ensuring transparency and convenience.


                            </div>
                            <div>
                                <span className="fw-semi-bold">Fare Estimates & Secure Payments (Taxi):
                                    &nbsp;</span>
                                Transparent fare estimates are provided before booking, with secure payment gateways ensuring safe transactions for users.


                            </div>

                        </div>
                        <div className="card-container bg-white text-gray">
                            <div>
                                <span className="fw-semi-bold">
                                    Vehicle Options for Cargo (Goods Transport):
                                    &nbsp;
                                </span>
                                Businesses can choose from a range of vehicles tailored to their cargo size and weight, ensuring flexible transport solutions for various logistics needs.

                            </div>
                            <div>
                                <span className="fw-semi-bold">
                                    Real-Time Tracking & Delivery Updates (Goods Transport):
                                    &nbsp;
                                </span>
                                &nbsp;Users can track their goods in transit with real-time updates, ensuring timely deliveries and status notifications throughout the journey.


                            </div>
                            <div>
                                <span className="fw-semi-bold">
                                    Secure & Efficient Payment System (Goods Transport):

                                    &nbsp;&nbsp;
                                </span>
                                &nbsp;The platform will offer secure payment options with transparent pricing, ensuring trust and efficiency for businesses and individuals alike.


                            </div>
                        </div>
                    </div>
                </section>
                <Contactus />
            </div></>
    )
}

export default Truck